import {MOCK_NEWSLETTER_SECTION} from './mock-newsletter';
import {CustomPage} from '../../models/page-builder/custom-page.model';
import {MOCK_PAGE_HEADER_SECTION} from './mock-page-header';
import { MOCK_PAGE_TESTIMONIAL_SECTION } from "./mock-testimonial";
import { MOCK_CTA_SECTION } from './mock-CTA';
import { MOCK_PAGE_RICH_TEXT_SECTION } from "./mock-rich-text";
import { MOCK_BENEFITS_SECTION } from './mock-benefits';
import { MOCK_PAGE_HTML_CODE_SECTION } from "./mock-html-code";
import { MOCK_PAGE_FAQ_SECTION } from "./mock-faq";
import { MOCK_COURSE_CARDS_SECTION } from './mock-course-cards';
import { MOCK_PAGE_HIGHLIGHTED_BOX_SECTION } from "./mock-highlighted-box";
import { MOCK_LATEST_LESSONS } from "./mock-latest-lessons";
import { MOCK_IMAGE_SECTION } from './mock-image';
import { MOCK_COURSE_CONTENT_SECTION } from "./mock-course-content";
import { MOCK_BUNDLE_SECTION } from './mock-bundle';



export const MOCK_PAGE_1: CustomPage = {
    id: "1",
        type: 'custom-page',
    title: "Example Landing Page",
    url: 'example-landing-page',
    status: 'draft',
    description: 'This is an example landing page, with one section of each type',
    imageUrl: "TODO",
    sections: [
      MOCK_PAGE_HEADER_SECTION,
      MOCK_COURSE_CONTENT_SECTION,
      MOCK_LATEST_LESSONS,
      MOCK_PAGE_HIGHLIGHTED_BOX_SECTION,
      MOCK_PAGE_FAQ_SECTION,
      MOCK_PAGE_HTML_CODE_SECTION,
      MOCK_PAGE_RICH_TEXT_SECTION,
      MOCK_PAGE_TESTIMONIAL_SECTION,
      MOCK_NEWSLETTER_SECTION,
      MOCK_CTA_SECTION,
      MOCK_BENEFITS_SECTION,
      MOCK_COURSE_CARDS_SECTION,
      MOCK_IMAGE_SECTION,
      MOCK_BUNDLE_SECTION
    ],
    createdAt: null,
  lastUpdatedAt: null
};
